import { Box } from "@mui/material";

import BannerCloseButton from "./BannerCloseButton";

interface Props {
  color?: string;
  children: React.ReactNode;
  onClick: () => void;
}

const BannerWrapper = ({ children, color, onClick }: Props) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "relative",
        background: "linear-gradient(90deg, #0c1f3c 0%, #122c52 100%)",
        py: 1,
        color: "#fff",
        pl: { xs: 1, md: 2 },
        pr: { xs: 4, md: 5 },
        display: "flex",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
        gap: { xs: 1, md: 2 },
        cursor: "pointer",
        "&:hover": {
          opacity: 0.9,
        },
      }}
    >
      {children}
      <BannerCloseButton />
    </Box>
  );
};
export default BannerWrapper;
